import Vue from 'vue';
import VueRouter from 'vue-router';
import qs from 'qs';
//另一种请求数据的方式
import axios from 'axios';
axios.defaults.withCredentials = true;
Vue.prototype.$localUrl = 'localhost:4005'
Vue.prototype.$ajax = axios;
axios.defaults.baseURL = process.env.NODE_ENV === "production" ? "" : "http://" + Vue.prototype.$localUrl;
Vue.prototype.$downloadFile = (url) => {
  try {
    let elemIF = document.createElement("iframe")
    elemIF.src = url
    elemIF.style.display = "none"
    document.body.appendChild(elemIF)
  } catch (e) {
    console.error(e)
  }
}
// axios.defaults.headers.common['Authorization'] = "AUTH_TOKEN";
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.port = 4005;

//导入element框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
//导入echart插件
import echarts from "echarts";


//导入公共样式
import "./statics/css/common.css";
import "./statics/css/messageBox.css";
import "./statics/js/common.js";



//导入组件
import App from './App.vue';
import enterpriseTrend from "./components/enterpriseTrend/enterpriseTrend.vue";
import enterpriseStatistics from "./components/enterpriseStatistics/enterpriseStatistics.vue";
import enterpriseOrder from "./components/enterpriseOrder/enterpriseOrder.vue";
import enterpriseManage from "./components/enterpriseManage/enterpriseManage.vue";
import companyObserve from "./components/companyObserve/companyObserve.vue";
import enterpriseWebsite from "./components/enterpriseWebsite/enterpriseWebsite.vue";
import systemSetup from "./components/systemSetup/systemSetup.vue";
import bgSet from "./components/bgSet/bgSet.vue";
import loginLs from "./components/login/loginls.vue";
import home from "./components/home/home.vue";
import notFound from "./components/404/404.vue";

//启用
Vue.use(ElementUI);
Vue.use(VueRouter);

//设置路由规则
const router = new VueRouter({
  routes: [{
      path: "/loginLs",
      component: loginLs,
      name: "登录",
      hidden: true
    },
    {
      // 兼容旧书签: index.html#LoginLs
      path: "/LoginLs",
      redirect: "/loginLs",
      hidden: true
    },

    {
      path: "/",
      component: home,
      redirect: {
        path: "/loginLs",
        component: loginLs,
        name: "登录"

      },
      children: [{
          path: "/enterpriseTrend",
          component: enterpriseTrend,
          name: "企业趋势"
        },
        {
          path: "/enterpriseStatistics",
          component: enterpriseStatistics,
          name: "企业统计"
        },
        {
          path: "/enterpriseOrder",
          component: enterpriseOrder,
          name: "企业订单"
        },
        {
          path: "/enterpriseManage",
          component: enterpriseManage,
          name: "/企业管理"
        },
        {
          path: "/companyObserve",
          component: companyObserve,
          name: "企业观察"
        },
        {
          path: "/enterpriseWebsite",
          component: enterpriseWebsite,
          name: "企业网站"
        },
        {
          path: "/systemSetup",
          component: systemSetup,
          name: "/系统设置"
        },
        {
          path: "/bgSet",
          component: bgSet,
          name: "/后台设置"
        }
      ]
    },
    {
      path: "/404",
      component: notFound,
      name: '',
      hidden: true
    },
    {
      path: "*",
      redirect: {
        path: "/404"
      }
    }

  ]
})

router.beforeEach((to, from, next) => {

 if(!window.sessionStorage.getItem("routerAcc") && to.path != "/loginLs") {
    next({path:"/loginLs",name: "登录"})
  }else {
    next()
  }
})



new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js